function Lightbox() {
	const button = document.querySelector('.block-location-chart__button .c-btn[data-modal-trigger]');
	const close = document.querySelector('.block-location-chart-modal__close');

	if (button) {
		button.addEventListener('click', function() {
			document.body.classList.toggle('lightbox-overlay');
		});
	}

	if (close) {
		close.addEventListener('click', function() {
			document.body.classList.remove('lightbox-overlay');
		});
	}
}

export default Lightbox;